/** 布局矩阵 HID（xsKeycode）→ HFD keyIndex（改键/灯光槽位），对齐 ai-hub huafendaKeymap */
export const LAYOUT_CODE_TO_HUAFENDA_KEY_INDEX: Readonly<
  Record<number, number>
> = {
  4: 49,
  5: 69,
  6: 67,
  7: 51,
  8: 35,
  9: 52,
  10: 53,
  11: 54,
  12: 40,
  13: 55,
  14: 56,
  15: 57,
  16: 71,
  17: 70,
  18: 41,
  19: 42,
  20: 33,
  21: 36,
  22: 50,
  23: 37,
  24: 39,
  25: 68,
  26: 34,
  27: 66,
  28: 38,
  29: 65,
  30: 17,
  31: 18,
  32: 19,
  33: 20,
  34: 21,
  35: 22,
  36: 23,
  37: 24,
  38: 25,
  39: 26,
  40: 76,
  41: 0,
  42: 92,
  43: 32,
  44: 83,
  45: 27,
  46: 28,
  47: 43,
  48: 44,
  49: 60,
  51: 58,
  52: 59,
  53: 16,
  54: 72,
  55: 73,
  56: 74,
  57: 48,
  58: 1,
  59: 2,
  60: 3,
  61: 4,
  62: 5,
  63: 6,
  64: 7,
  65: 8,
  66: 9,
  67: 10,
  68: 11,
  69: 12,
  70: 99,
  71: 100,
  72: 102,
  73: 103,
  74: 104,
  75: 105,
  76: 106,
  77: 107,
  78: 108,
  79: 91,
  80: 88,
  81: 89,
  82: 90,
  83: 29,
  84: 30,
  85: 31,
  86: 109,
  87: 110,
  88: 95,
  89: 77,
  90: 78,
  91: 79,
  92: 61,
  93: 62,
  94: 63,
  95: 45,
  96: 46,
  97: 47,
  98: 93,
  99: 94,
  101: 86,
  8418: 15,
  8425: 13,
  8426: 14,
  224: 80,
  225: 64,
  226: 82,
  227: 81,
  228: 87,
  229: 75,
  230: 84,
  61697: 85,
};

export function resolveHuafendaKeyIndex(layoutCode: number): number {
  if (layoutCode <= 0) return -1;
  const keyIndex = LAYOUT_CODE_TO_HUAFENDA_KEY_INDEX[layoutCode];
  return keyIndex === undefined ? -1 : keyIndex;
}

/** SMART875 / 84% TKL 骨架矩阵，对齐 KEYCODE_MAP_HFD_LAYOUT["84"] */
export const HUAFENDA84_LAYOUT_MATRIX: Readonly<number[][]> = [
  [
    41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 70, 72, 0, 0, 0,
    0,
  ],
  [
    53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 74, 75, 0, 0, 0, 0,
    0,
  ],
  [
    43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 77, 78, 0, 0, 0, 0,
    0,
  ],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40, 0, 0, 0, 0, 0, 0, 0],
  [225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 0, 0, 0, 0, 0],
  [
    224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 0, 0, 0,
    0, 0,
  ],
];

/** 华奋达 X87 / X87 V2 骨架矩阵（21 列），对齐 LAYOUT_HUAFENDA87_KEYCODES */
export const HUAFENDA87_LAYOUT_MATRIX: Readonly<number[][]> = [
  [
    41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 0, 0, 0, 0,
    0,
  ],
  [
    53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 73, 74, 75, 0, 0, 0,
    0,
  ],
  [
    43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 77, 78, 0, 0, 0,
    0,
  ],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 0, 0, 0, 0, 0, 0, 0, 0],
  [225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 0, 0, 0, 0, 0, 0],
  [
    224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 101, 228, 80, 81, 79, 0, 0,
    0, 0,
  ],
];

/** M98 / M98 Screen 骨架矩阵（21 列），对齐 LAYOUT_M98_KEYCODES / LAYOUT_M98TFT_KEYCODES */
export const HUAFENDA_M98_LAYOUT_MATRIX: Readonly<number[][]> = [
  [
    41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 75, 78, 74, 8418, 0,
    0, 0,
  ],
  [
    53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 83, 84, 85, 86, 0,
    0, 0,
  ],
  [
    43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 95, 96, 97, 87, 0, 0,
    0,
  ],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 92, 93, 94, 0, 0, 0, 0, 0],
  [
    225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 89, 90, 91, 88, 0, 0, 0,
    0,
  ],
  [
    224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 98, 99, 0,
    0, 0,
  ],
];

/** DK108：108 键全尺寸 ANSI（6×21）；已与实机 SDK getKeyData 校准通过 */
export const HUAFENDA_DK108_LAYOUT_MATRIX: Readonly<number[][]> = [
  [
    41, 0, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 8374,
    8397, 8373, 62208,
  ],
  [
    53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 73, 74, 75, 83, 84,
    85, 86,
  ],
  [
    43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 76, 77, 78, 95, 96,
    97, 87,
  ],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 0, 40, 0, 0, 0, 92, 93, 94, 0],
  [
    225, 0, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 0, 0, 82, 0, 89, 90, 91,
    88,
  ],
  [
    224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 101, 228, 80, 81, 79, 98,
    99, 0, 0,
  ],
];

export const HUAFENDA_M98TFT_LAYOUT_MATRIX: Readonly<number[][]> = [
  [
    41, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 76, 0, 0, 0, 8418, 0, 0,
    0,
  ],
  [
    53, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 45, 46, 42, 83, 84, 85, 86, 0,
    0, 0,
  ],
  [
    43, 20, 26, 8, 21, 23, 28, 24, 12, 18, 19, 47, 48, 49, 95, 96, 97, 87, 0, 0,
    0,
  ],
  [57, 4, 22, 7, 9, 10, 11, 13, 14, 15, 51, 52, 40, 92, 93, 94, 0, 0, 0, 0, 0],
  [
    225, 29, 27, 6, 25, 5, 17, 16, 54, 55, 56, 229, 82, 89, 90, 91, 88, 0, 0, 0,
    0,
  ],
  [
    224, 227, 226, 0, 0, 0, 44, 0, 0, 0, 230, 61697, 228, 80, 81, 79, 98, 99, 0,
    0, 0,
  ],
];

/** layoutCode → Web KeyboardEvent.code（华奋达 X87 常用键） */
export const LAYOUT_CODE_TO_WEB_KEY: Readonly<Record<number, string>> = {
  4: "KeyA",
  5: "KeyB",
  6: "KeyC",
  7: "KeyD",
  8: "KeyE",
  9: "KeyF",
  10: "KeyG",
  11: "KeyH",
  12: "KeyI",
  13: "KeyJ",
  14: "KeyK",
  15: "KeyL",
  16: "KeyM",
  17: "KeyN",
  18: "KeyO",
  19: "KeyP",
  20: "KeyQ",
  21: "KeyR",
  22: "KeyS",
  23: "KeyT",
  24: "KeyU",
  25: "KeyV",
  26: "KeyW",
  27: "KeyX",
  28: "KeyY",
  29: "KeyZ",
  30: "Digit1",
  31: "Digit2",
  32: "Digit3",
  33: "Digit4",
  34: "Digit5",
  35: "Digit6",
  36: "Digit7",
  37: "Digit8",
  38: "Digit9",
  39: "Digit0",
  40: "Enter",
  41: "Escape",
  42: "Backspace",
  43: "Tab",
  44: "Space",
  45: "Minus",
  46: "Equal",
  47: "BracketLeft",
  48: "BracketRight",
  49: "Backslash",
  51: "Semicolon",
  52: "Quote",
  53: "Backquote",
  54: "Comma",
  55: "Period",
  56: "Slash",
  57: "CapsLock",
  58: "F1",
  59: "F2",
  60: "F3",
  61: "F4",
  62: "F5",
  63: "F6",
  64: "F7",
  65: "F8",
  66: "F9",
  67: "F10",
  68: "F11",
  69: "F12",
  70: "PrintScreen",
  71: "ScrollLock",
  72: "Pause",
  73: "Insert",
  74: "Home",
  75: "PageUp",
  76: "Delete",
  77: "End",
  78: "PageDown",
  79: "ArrowRight",
  80: "ArrowLeft",
  81: "ArrowDown",
  82: "ArrowUp",
  83: "NumpadLock",
  84: "NumpadDivide",
  85: "NumpadMultiply",
  86: "NumpadSubtract",
  87: "NumpadAdd",
  88: "NumpadEnter",
  89: "Numpad1",
  90: "Numpad2",
  91: "Numpad3",
  92: "Numpad4",
  93: "Numpad5",
  94: "Numpad6",
  95: "Numpad7",
  96: "Numpad8",
  97: "Numpad9",
  98: "Numpad0",
  99: "NumpadDecimal",
  101: "ContextMenu",
  8418: "KEY_8418",
  224: "ControlLeft",
  225: "ShiftLeft",
  226: "AltLeft",
  227: "MetaLeft",
  228: "ControlRight",
  229: "ShiftRight",
  230: "AltRight",
  61697: "Fn1",
};
